var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCds = function SvgCds(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "37.072%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F0F0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F0F0F5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 28,
    y: 4,
    fill: "#D01E29",
    rx: 2.09
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    stroke: "#BEBFCB",
    d: "M26.5 5.883L21.65.5H6.676C6.038.5 5.5 1.098 5.5 1.86v24.314c.016.748.549 1.326 1.175 1.326h18.65c.626 0 1.16-.578 1.175-1.315V5.883z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A7B8E",
    d: "M23.2 14a.8.8 0 1 1 0 1.6H8.8a.8.8 0 1 1 0-1.6h14.4zm0-4a.8.8 0 1 1 0 1.6H8.8a.8.8 0 1 1 0-1.6h14.4zM16 6a.8.8 0 1 1 0 1.6H8.8a.8.8 0 1 1 0-1.6H16zm-5.028 17.776c-.379 0-.72-.06-1.024-.18a2.03 2.03 0 0 1-.776-.536 2.468 2.468 0 0 1-.496-.888 3.967 3.967 0 0 1-.176-1.244c0-.47.059-.887.176-1.252a2.62 2.62 0 0 1 .496-.92c.213-.248.472-.436.776-.564A2.615 2.615 0 0 1 10.972 18c.517 0 .944.105 1.28.316.336.21.605.543.808.996l-1.048.544a1.247 1.247 0 0 0-.348-.564c-.157-.141-.388-.212-.692-.212-.357 0-.644.116-.86.348-.216.232-.324.57-.324 1.012v.896c0 .443.108.78.324 1.012.216.232.503.348.86.348.299 0 .537-.081.716-.244.179-.163.31-.359.396-.588l.992.576c-.208.427-.481.756-.82.988-.339.232-.767.348-1.284.348zm2.952-5.68h2.104c.368 0 .704.059 1.008.176.304.117.563.292.776.524.213.232.379.523.496.872.117.35.176.756.176 1.22 0 .464-.059.87-.176 1.22-.117.35-.283.64-.496.872a2.032 2.032 0 0 1-.776.524c-.304.117-.64.176-1.008.176h-2.104v-5.584zm2.104 4.504c.363 0 .648-.101.856-.304.208-.203.312-.528.312-.976v-.864c0-.448-.104-.773-.312-.976-.208-.203-.493-.304-.856-.304h-.888V22.6h.888zm5.28 1.176c-.49 0-.907-.084-1.248-.252a2.854 2.854 0 0 1-.872-.652l.8-.808c.379.427.845.64 1.4.64.299 0 .52-.061.664-.184a.61.61 0 0 0 .216-.488.592.592 0 0 0-.128-.388c-.085-.104-.259-.175-.52-.212l-.552-.072c-.592-.075-1.025-.253-1.3-.536-.275-.283-.412-.659-.412-1.128 0-.25.048-.48.144-.688.096-.208.233-.387.412-.536.179-.15.397-.265.656-.348.259-.083.553-.124.884-.124.421 0 .792.067 1.112.2.32.133.595.328.824.584l-.808.816a1.62 1.62 0 0 0-.484-.38c-.19-.099-.428-.148-.716-.148-.272 0-.475.048-.608.144a.465.465 0 0 0-.2.4c0 .192.052.33.156.416.104.085.273.147.508.184l.552.088c.576.09 1.003.268 1.28.532.277.264.416.639.416 1.124 0 .267-.048.512-.144.736a1.577 1.577 0 0 1-.42.576c-.184.16-.412.284-.684.372a3.01 3.01 0 0 1-.928.132z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D2D3DD",
    fillRule: "nonzero",
    stroke: "#D2D3DD",
    d: "M21.242 1.044a.14.14 0 0 0-.242.102v4.438a.402.402 0 0 0 .414.408h4.39a.148.148 0 0 0 .095-.28l-4.657-4.668z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCds, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cds.f16ddbca.svg";
export { ForwardRef as ReactComponent };